import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    public static get(key: string): any {
        return this.has(key) ? JSON.parse(window.sessionStorage.getItem(key)) : undefined;
    }

    public static set(key: string, value: any): void {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    }

    public static has(key: string): boolean {
        return !!window.sessionStorage.getItem(key);
    }

    public static delete(key: string): void {
        window.sessionStorage.removeItem(key);
    }

    public static clear(): void {
        window.sessionStorage.clear();
    }
}
